import * as React from 'react';
import styled, { css } from 'styled-components';
import { ButtonColorType, Button } from '../../components/Button';
import { StredaRoundIcon } from '../../components/icons';
import { Text } from '../../components/Text';

const LoginPageContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  z-index: 99;
`;

const LoginPagePanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 40px 30px;
  margin-top: auto;
  margin-bottom: auto;
  background-color: #fff;
  max-width: 470px;
  height: max-content;
  border-color: #ddd;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
  .loaderCircle {
    width: calc(100%);
    height: calc(100%);
  }
`;

const LoginPagePanelBody = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

const ErrorContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const sharedTextStyle = css`
  font-style: normal;
  text-align: center;
  font-weight: 500;
`;

const MainErrorText = styled(Text)`
  ${sharedTextStyle};
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: rgba(18, 18, 18, 0.87);
`;

const AdditionalErrorText = styled(Text)`
  ${sharedTextStyle};
  font-size: 14px;
  line-height: 18px;
  color: rgba(18, 18, 18, 0.87);
`;

const TryAgainText = styled(Text)`
  ${sharedTextStyle};
  font-size: 14px;
  line-height: 18px;
  color: rgba(18, 18, 18, 0.87);
  cursor: pointer;
`;

export interface ILoginPageProps {
  onLoginHandler: () => void;
  loginInProgress: boolean;
  errorMsg?: string;
  additionalErrorMsg?: string;
}
const LoginPageComponent: React.FC<ILoginPageProps> = ({
  onLoginHandler,
  loginInProgress,
  errorMsg,
  additionalErrorMsg
}) => {
  const content = () => {
    return (errorMsg || additionalErrorMsg) && !loginInProgress ? (
      <ErrorContainer>
        <MainErrorText mb={18} mt={48}>
          {errorMsg || ''}
        </MainErrorText>
        <AdditionalErrorText mb={39}>
          {additionalErrorMsg || ''}
        </AdditionalErrorText>
        <TryAgainText mb={87} onClick={() => onLoginHandler()} role="button">
          Try again
        </TryAgainText>
      </ErrorContainer>
    ) : (
      <div style={{ margin: '87px 0px 50px 0px' }}>
        <Button
          className="login-button"
          colorType={ButtonColorType.UNIVERSAL}
          type="button"
          onClick={() => onLoginHandler()}
          text={loginInProgress ? 'Logging in...' : 'Login'}
        />
      </div>
    );
  };
  return (
    <LoginPageContainer>
      <LoginPagePanel className="col-lg-6">
        <StredaRoundIcon loading={loginInProgress} />
        <LoginPagePanelBody>{content()}</LoginPagePanelBody>
      </LoginPagePanel>
    </LoginPageContainer>
  );
};

export default LoginPageComponent;
